$(function() {

    function buttonSVGDimensions() {
        $('div.button-wrap .button, div.button-wrap .cta').each(function(){
            var thisButton = $(this);
            var buttonHeight = thisButton.height();

            // var initialSize = 10.5 / 50;
            var initialSize = 0.2044;
            var newWidth = initialSize * buttonHeight;
            var newHeight = buttonHeight;

            if ( $(this).hasClass('direction') ) {

                // var directionSize = 22 / 50;
                var directionSize = 0.4016666666;
                var directionWidth = directionSize * buttonHeight;
                
                if ( $(this).hasClass('left') ) {
                    thisButton.find('.edge.left').css({width:directionWidth,height:newHeight});
                    thisButton.find('.edge.right').css({width:newWidth,height:newHeight});
                }

                if ( $(this).hasClass('right') ) {
                    thisButton.find('.edge.left').css({width:newWidth,height:newHeight});
                    thisButton.find('.edge.right').css({width:directionWidth,height:newHeight});
                }

            } else {
                thisButton.find('.edge').css({width:newWidth,height:newHeight});

            }

        });
    }

    // if IE 11
    if( navigator.userAgent.match(/Trident.*rv:11\./) ) {

        $('body').addClass('ie11');

        // fix SVG buttons
        buttonSVGDimensions();
        
    }

    // open sub nav
    $('#main-nav li.has-children').on('click',function(e){
        e.preventDefault();
        e.stopPropagation();

        $(this).toggleClass('active');

    });
    // allows sub-nav menu clicks when sub-nav is open
    $('#main-nav li.has-children ul.main-nav-inner').on('click',function(e){
        e.stopPropagation();
    });

    // if sub nav is open, close it
    $('body').on('click',function(){
        if ( $('#main-nav li.has-children').hasClass('active') ) {
            $('#main-nav li.has-children').removeClass('active');
        }
    });


    // open mobile nav
    $('div.hamburger-wrap div.flex-inner').on('click',function(e){
        e.preventDefault();

        $(this).toggleClass('active');
        $('button.hamburger').toggleClass('is-active');

        $('div.nav-wrap').toggleClass('open');

        $('body').toggleClass('noscroll');

    });

    if ( $('#home-instagram').length || $('#footer-instagram').length ) {

        var instagram_UserID = '3006934221';
        var instagram_clientId = 'baa01b69305442dfa8ac7b922b74c065';
        var instagram_accessToken = '3006934221.1677ed0.3cc3f27addec4616a97a7f48336a1413';

        if ( $('#home-instagram').length ) {
            var instagram_target = 'home-instagram';
            var instagram_limit = 6;
        }

        if ( $('#footer-instagram').length ) {
            var instagram_target = 'footer-instagram';
            var instagram_limit = 4;
        }

        var feed = new Instafeed({
            get: 'user',
            userId: instagram_UserID,
            clientId: instagram_clientId,
            accessToken: instagram_accessToken,
            limit: instagram_limit,
            target: instagram_target,
            template: '<li><a target="_blank" href="{{link}}" style="background-image:url({{image}});"></a></li>',
            resolution: 'standard_resolution'
        });
        feed.run();
    }


    $(window).on('resize',function(){

        // if window is larger than 768 and nav-wrap has a class of open,
        // reset the mobile nav to it's closed state
        if ( $(window).width() > 768 && $('div.nav-wrap').hasClass('open') ) {
            $('#main-nav li.has-children').removeClass('active');
            $('div.hamburger-wrap div.flex-inner').removeClass('active');
            $('button.hamburger').removeClass('is-active');
            $('div.nav-wrap').removeClass('open');
            $('body').removeClass('noscroll');
        }

    });


    if( $('body').hasClass('craft') ) {
 
        $.ajax({
            type: 'GET',
            url: 'https://shop.valleylahvosh.com/cart.js',
            dataType: 'jsonp',
            success: function(cartdata){
                console.log( cartdata.item_count );
            }
        });

        // $.ajax({
        //     type: 'GET',
        //     url: 'https://valleylahvosh.myshopify.com/cart.json',
        //     dataType: 'jsonp',
        //     success: function(data) { 
        //         var item_count = data['item_count'];

        //         console.log( item_count );
        //     }
        // });

    }


    // $('div.text-wrap a').on('click',function(e){
    //     e.preventDefault();

    //     var siteUrl = window.location.protocol + '//' + window.location.hostname;
    //     var linkHref = $(this).attr('href');

    //     if( linkHref.indexOf(siteUrl) != -1 ){
    //         window.location.href = linkHref;
    //     } else {
    //         window.open( linkHref );
    //     }
        
    // });

    $('div.share-print-wrap span').on('click',function(e){
        e.preventDefault();

        if( $(this).hasClass('share') ) {
            $('body').addClass('noscroll');
            $('div.share-modal').addClass('active');
        }

        if( $(this).hasClass('print') ) {
            javascript:window.print();
        }
    });

    $('div.share-modal').on('click',function(){
        $('body').removeClass('noscroll');
        $('div.share-modal').removeClass('active');
    });
    $('div.share-modal div.modal-inner').on('click',function(e){
        e.stopPropagation();
    });
    $('div.share-modal div.close').on('click',function(){
        $('body').removeClass('noscroll');
        $('div.share-modal').removeClass('active');
    });
    $('div.share-modal input').on('click',function(){
        $(this).select();
    });

    // var $form = $('form#mc-embedded-subscribe-form');
    if ($('form#mc-embedded-subscribe-form').length > 0) {
        $('form#mc-embedded-subscribe-form').submit(function(e){
            e.preventDefault();

            // $.ajax({
            //     url: '/',
            //     type: 'post',
            //     dataType: 'json',
            //     data: $('form#form-mailchimp-sign-up').serialize()
            // }).done(function(response){
            //     // console.log('done');
            //     // console.log(response);
    
            //     if(response.success){
            //         $('#marketing-opt-in-form-wrapper').toggleClass('visible');
            //         $('#marketing-opt-in-success-wrapper').toggleClass('visible');
            //     }else{
            //         $('button', e.target).prop('disabled', false);
            //         $('#wheel-wrapper', e.target).removeClass('visible');
    
            //         alert(response.message);
            //     }
            // }).fail(function(error){
            //     console.log('fail');
            //     console.log(error);
            // });

            $.ajax({
                url: '/',
                type: 'post',
                dataType: 'json',
                data: $('form#mc-embedded-subscribe-form').serialize()
            }).done(function(response){
                // $('#mc-embedded-subscribe').val('subscribe');
    
                if(response.success){
                    $('#mc_embed_signup label.start').hide();
                    $('#mc_embed_signup label.success').fadeIn();
                    $('#mce-EMAIL').val('');
                }else{
                    console.log('status is not success');
                    console.log(response);
                }
            }).fail(function(error){
                console.log('fail');
                console.log(error);
            });
        });
    }

});